export const UPDATE_RESULTS_QSEB_FAILURE = 'UPDATE_RESULTS_QSEB_FAILURE';

export const updateResultsQsebFailure = error => ({
    type: UPDATE_RESULTS_QSEB_FAILURE,
    payload: error,
    error: true,
});
